import Rest from '@services/Rest';

/**
 * @typedef {DownloadService}
 */
export default class DownloadService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/download'
}